/**
 * FabTooltip — pill-style hover tooltip that appears to the LEFT of a floating
 * action button.  Matches the top-nav hover-tooltip aesthetic.  Wrap around any
 * fixed-position button that already has its own layout.
 *
 * Because the child button is `position:fixed` and drives its own placement,
 * the wrapper is `display:contents` so the tooltip absolutely-positions
 * against the same viewport spot as the button.
 *
 * Usage:
 *   <FabTooltip label="Search">
 *     <button className="fixed ..." style={{ right:'1.5rem', top:'6.75rem' }}>...</button>
 *   </FabTooltip>
 */
import { cloneElement, Children, isValidElement } from 'react';

export default function FabTooltip({ label, children }) {
  const child = Children.only(children);
  if (!isValidElement(child)) return children;

  // Inject the tooltip as a sibling element inside the same fixed button.
  // We wrap the FAB in a group so `group-hover` reveals the tooltip.
  return cloneElement(child, {
    className: `${child.props.className || ''} group`,
    children: (
      <>
        {child.props.children}
        <span
          role="tooltip"
          className="pointer-events-none absolute right-full mr-2.5 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-navy text-white text-[11px] font-medium px-2.5 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150 shadow-lg"
        >
          {label}
        </span>
      </>
    ),
  });
}
